import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { User } from '../../../user/user.model';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {

  constructor(public authService: AuthService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    // console.log(this.authService.currentUser);
    // this.currentUser = this.authService.currentUser;

    // console.log('settings are here', this.settingsService.userSettingsValues);
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  setNavbarSetting() {

    this.authService.currentUser.userSettings.navbarPinned = !this.authService.currentUser.userSettings.navbarPinned;
    this.authService.saveCurrentUser();

  }


  // hierarchical user roles - may need to adjust later
  isSuperAdmin() { return this.authService.isSuperAdmin(); }
  isAdmin() { return this.authService.isAdmin(); }
  isManager() { return this.authService.isManager(); }
  isUser() { return this.authService.isUser(); }
  isExternalUser() { return this.authService.isExternalUser(); }
  isAli() { return this.authService.currentUser.firstName === 'Ali'; }
  isClient() { return this.authService.isClient(); }

}



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/navbar/navbar.component.ts